import React from "react"

import type { NumberInputFieldProps, NumberInputProps } from "@chakra-ui/react"
import {
  forwardRef,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from "@chakra-ui/react"

import { formatCurrency, parseCurrency } from "@supliful/domain"

import type { EditorProps } from "./Editor"

type NumberEditorProps = {
  dataTestId?: string
  inputProps?: NumberInputFieldProps
} & EditorProps<number> &
  Omit<NumberInputProps, "parse" | "format">

export const NumberEditor = forwardRef(
  (
    {
      value,
      isValueInvalid,
      onValueChange,
      dataTestId,
      inputProps,
      ...props
    }: NumberEditorProps,
    ref,
  ) => {
    return (
      <NumberInput
        defaultValue={formatCurrency(value)}
        isInvalid={isValueInvalid}
        min={0}
        precision={2}
        step={1}
        onBlur={(event) => {
          if (onValueChange) {
            onValueChange(parseCurrency(event.currentTarget.value))
          }
        }}
        focusBorderColor="main.700"
        {...props}
        data-testid={dataTestId ? dataTestId : ""}
      >
        <NumberInputField
          ref={ref}
          minWidth={16}
          pl={{ base: 2, md: 4 }}
          fontSize={{ base: 12, sm: 14 }}
          {...inputProps}
        />

        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
    )
  },
)
